import styled from 'academy-common-lib/utils/Styling';
import PublicPageNavigation from './PublicPageNavigation';
import PublicPageFooterMinimal from './PublicPageFooterMinimal';
import Footer from './footer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicPageWrapper = styled.div.withConfig({
  displayName: "PublicPageLayout__PublicPageWrapper",
  componentId: "sc-1xriwrk-0"
})(["height:100vh;display:flex;flex-direction:column;"]);
const PublicPageLayout = ({
  children,
  availableLanguages,
  languageLinkedContent,
  contentType,
  pagePath,
  footerType = 'full'
}) => {
  return /*#__PURE__*/_jsxs(PublicPageWrapper, {
    children: [/*#__PURE__*/_jsx(PublicPageNavigation, {
      availableLanguages: availableLanguages,
      contentType: contentType,
      languageLinkedContent: languageLinkedContent,
      pagePath: pagePath
    }), /*#__PURE__*/_jsx("main", {
      children: /*#__PURE__*/_jsx("div", {
        style: {
          minHeight: 'calc(100vh - 160px)'
        },
        children: children
      })
    }), footerType === 'minimal' ? /*#__PURE__*/_jsx(PublicPageFooterMinimal, {}) : /*#__PURE__*/_jsx(Footer, {})]
  });
};
export default PublicPageLayout;